import React, {useEffect, useLayoutEffect, useState} from "react";
import styled from "styled-components";
import {useNavigate, useNavigationType} from "react-router";
import {batch, useDispatch, useSelector} from "react-redux";
import {
	fetchDetailBranchPageScroll,
	fetchDetailSummaryInfo,
	fetchBranchSummaryInfo,
	updateBranchPeriodInfo
} from "redux/slices/sales/salesSlice";

import {getCommaNumber} from "utils/format";
import iconChevron from "assets/icons/icon_chevron_black.svg";

import Filter from "components/ui/Filter";
import Observer from "components/ui/Observer";



/**
 * [전지점 기간별 매출 목록]
 */

export const BranchDetailList = ({mode}) => {
	const navigate = useNavigate();
	const navigationType = useNavigationType();

	const dispatch = useDispatch();
	const {
		searchPartner,
		searchBranch,
		searchDate,
		searchPeriodType,
		searchFilter,
	} = useSelector(state => state.sales.branchSummaryInfo);

	const {
		data,
		page,
		pageSize,
		pageState
	} = useSelector(state => state.sales.branchPeriodInfo);

	useLayoutEffect(() => {
		dispatch(fetchDetailBranchPageScroll("restore"));
	}, []);

	useEffect(() => {
		const isUpdate = (
			!data || navigationType != "POP" || (
				searchPartner != data.searchInfo.searchPartner ||
				searchBranch != data.searchInfo.searchBranch ||
				searchDate != data.searchInfo.searchDate ||
				searchPeriodType != data.searchInfo.searchPeriodType ||
				searchFilter != data.searchInfo.searchFilter
			)
		);
		if(isUpdate) {
			if(pageState != undefined) {
				dispatch(updateBranchPeriodInfo(false));
			}
		}
	}, [searchPartner, searchBranch, searchDate, searchPeriodType, searchFilter]);

	const eventHandler = {
		updateList : () => {
			dispatch(updateBranchPeriodInfo(true));
		},
		info : (searchBranch) => {
			batch(() => {
				dispatch(fetchDetailSummaryInfo({
					searchPartner : searchPartner,
					searchBranch : searchBranch,
					searchDate : data.searchInfo.searchDate
				}));
				navigate("/sales/" + mode + "/" + searchBranch);
			});
		},
		changeFilter : (name, value) => {
			dispatch(fetchBranchSummaryInfo({
				searchFilter : value
			}));
		}
	};

	const render = () => {
		const li = ((data || {}).overviewList || []).map((item, index) => {
			const totalAmount = (item.bpaySalesAmount || 0) + (item.crmSalesAmount || 0);
			return (
				<li key={item.seqPartnerBranch || index}>
					<a onClick={() => {eventHandler.info(item.seqPartnerBranch)}}>
						<ul>
							<li>
								<div>{item.branchName}</div>
								<div>{getCommaNumber(totalAmount)}원</div>
							</li>
							<li>
								<div>b.pay<span>{item.bpaySalesCount}건</span></div>
								<div>{getCommaNumber(item.bpaySalesAmount)}원</div>
							</li>
							<li>
								<div>현장판매<span>{item.crmSalesCount}건</span></div>
								<div>{getCommaNumber(item.crmSalesAmount)}원</div>
							</li>
						</ul>
					</a>
				</li>
			);
		});

		const filterList = [{
			label : "매출순",
			value : "SALES",
		}, {
			label : "이름순",
			value : "NAMES"
		}];

		return (
			<Wrapper>
				<Filter
					title="지점별 정렬" value={searchFilter}
					options={filterList} onChange={eventHandler.changeFilter}
					isSticky={true}
				/>
				<div className="list">
					<ul>{li}</ul>
				</div>
				<Observer isActive={pageState} isLoading={true} onVisible={eventHandler.updateList}></Observer>
			</Wrapper>
		);
	};
	return render();
};

const Wrapper = styled.div`
.list									{padding:0 24px}
.list > ul > li a						{display:block; padding:20px 0}
.list > ul > li + li					{border-top:1px solid var(--lightBorder)}

.list ul ul li							{display:flex; align-items:center; justify-content:space-between}
.list li div + div						{text-align:right; color:var(--darkGray)}

.list li div:first-child				{font-size:var(--16px)}
.list li ul li							{padding:2px 0}
.list li ul li:first-child				{margin-bottom:2px}
.list li ul li:first-child div			{font-size:var(--18px); font-weight:600}
.list li ul li:first-child div + div	{margin-right:-2px; padding-right:0.75em; background:url(${iconChevron}) no-repeat center right; color:var(--black)}
.list li div span						{font-size:var(--14px); color:var(--gray)}
.list li div span:before				{content:" · "}
`;

export default BranchDetailList;